<template>
    <div class="register">
    <label id="label">Email Address</label>
    <input
      id="email"
      type="email"
      v-model="email"
      :class="{ error: hasError }"
      @keyup.enter="validateEmail"
    />
    <transition name="fade">
      <p v-if="hasError" class="errorInfo">Enter a valid email address.</p>
    </transition>
    <transition name="fade">
      <p v-if="hasDomainError" class="errorInfo">Your email address is not allowed.</p>
    </transition>
    <a id="button" class="btn center" @click="validateEmail">Submit</a>

  </div>
  
</template>

<script>
import store from "@/store";
import { gsap } from '/src/assets/js/gsap';
import { mapGetters, mapActions } from "vuex"

export default {
    name: "Register",
    data: function () {
        return {
            chartData: {'category1': 9, 'category2': 20, 'category3':30, 'category4': 22 },
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            email: '',
            hasError: false,
            hasDomainError: false,
            domain: '',
            // allowedDomains: [
            //     'insight-experience.com',
            //     'insightxp.com',
            //     'thebiggerdesign.com',
            //     'epiccreature.com',
            //     // 'cvshealth.com',
            //     // 'aetna.com',
            //     // 'coramhc.com',
            //     // 'omnicare.com',
            //     // 'meritain.com'
            // ]
        }
    },
    computed : {
        ...mapGetters([
            "actionIndex"
        ])
    },
    methods: {
        validateEmail() {
            if (this.reg.test(this.email)) {
                this.hasError = false
                // if good, verify domain of email
                this.verifyDomain()        
            } else {
                this.hasError = true
            }
        },
        verifyDomain() {
            // const domain = this.email.split('@').pop()
            // if(this.allowedDomains.includes(domain)) {
            //     this.hasDomainError = false;
            //     this.domain = domain;
            //     this.userOK();
            // } else {
            //     this.hasDomainError = true;
            // }
            const domain = this.email.split('@').pop()
            this.hasDomainError = false;
            this.domain = domain;
            this.userOK();
        },
        userOK () {
            gsap.to('#label, #email, #button, footer', {
                autoAlpha : 0,
                duration : 0.5,
                stagger : {amount: 0.4},
                ease : 'sine.inOut',
                onComplete : this.goToOverview
            })
        },
        goToOverview () {
            store.dispatch("setEmail", this.email)
            this.$router.push({
                name : "overview"
            })
        }
    },
    mounted() {
        // set email if they're taking it again
        this.email = store.getters.getEmail;
        this.$gtag.event('register', { course: 'Communication' })
        this.$parent.appHeight();
    
        // animate in
        gsap.from('#label, #email, #button', {
            autoAlpha : 0,
            x : "-50px",
            stagger : {amount: .35},
            delay : 1.5,
            ease : 'sine.out'
        })
    }
}
</script>
